import { render, staticRenderFns } from "./CatalogBox.vue?vue&type=template&id=0ef9bf40&scoped=true&"
import script from "./CatalogBox.vue?vue&type=script&lang=js&"
export * from "./CatalogBox.vue?vue&type=script&lang=js&"
import style0 from "./CatalogBox.vue?vue&type=style&index=0&id=0ef9bf40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef9bf40",
  null
  
)

export default component.exports